import { CountryEnum as a } from "./country-enum.mjs";
import m from "../../_virtual/index.mjs";
import * as e from "../../node_modules/i18n-iso-countries/langs/ar.json.mjs";
import * as f from "../../node_modules/i18n-iso-countries/langs/cs.json.mjs";
import * as p from "../../node_modules/i18n-iso-countries/langs/da.json.mjs";
import * as n from "../../node_modules/i18n-iso-countries/langs/de.json.mjs";
import * as c from "../../node_modules/i18n-iso-countries/langs/el.json.mjs";
import * as u from "../../node_modules/i18n-iso-countries/langs/en.json.mjs";
import * as l from "../../node_modules/i18n-iso-countries/langs/es.json.mjs";
import * as g from "../../node_modules/i18n-iso-countries/langs/fr.json.mjs";
import * as d from "../../node_modules/i18n-iso-countries/langs/hi.json.mjs";
import * as h from "../../node_modules/i18n-iso-countries/langs/hu.json.mjs";
import * as L from "../../node_modules/i18n-iso-countries/langs/id.json.mjs";
import * as C from "../../node_modules/i18n-iso-countries/langs/it.json.mjs";
import * as E from "../../node_modules/i18n-iso-countries/langs/ja.json.mjs";
import * as N from "../../node_modules/i18n-iso-countries/langs/nl.json.mjs";
import * as y from "../../node_modules/i18n-iso-countries/langs/no.json.mjs";
import * as j from "../../node_modules/i18n-iso-countries/langs/pl.json.mjs";
import * as v from "../../node_modules/i18n-iso-countries/langs/pt.json.mjs";
import * as I from "../../node_modules/i18n-iso-countries/langs/ro.json.mjs";
import * as S from "../../node_modules/i18n-iso-countries/langs/ru.json.mjs";
import * as b from "../../node_modules/i18n-iso-countries/langs/sk.json.mjs";
import * as w from "../../node_modules/i18n-iso-countries/langs/sl.json.mjs";
import * as G from "../../node_modules/i18n-iso-countries/langs/sq.json.mjs";
import * as H from "../../node_modules/i18n-iso-countries/langs/sr.json.mjs";
import * as O from "../../node_modules/i18n-iso-countries/langs/sv.json.mjs";
import * as q from "../../node_modules/i18n-iso-countries/langs/th.json.mjs";
import * as x from "../../node_modules/i18n-iso-countries/langs/tr.json.mjs";
import * as z from "../../node_modules/i18n-iso-countries/langs/uk.json.mjs";
import * as B from "../../node_modules/i18n-iso-countries/langs/zh.json.mjs";
import { LocaleEnum as s } from "../../libs/types/dist/index11.mjs";
import { getLanguageCodeByLocale as D } from "../locales/language-utils.mjs";
const F = {
  ar: e,
  cs: f,
  da: p,
  de: n,
  el: c,
  en: u,
  es: l,
  fr: g,
  hi: d,
  hu: h,
  id: L,
  it: C,
  ja: E,
  nl: N,
  no: y,
  pl: j,
  pt: v,
  ro: I,
  ru: S,
  sk: b,
  sl: w,
  sq: G,
  sr: H,
  sv: O,
  th: q,
  tr: x,
  uk: z,
  zh: B
};
Object.values(F).forEach((r) => {
  m.registerLocale(r.default);
});
const i = (r, o) => {
  const t = D(o);
  switch (r) {
    // Related SC https://app.shortcut.com/systeme/story/15639/change-the-name-of-taiwan-province-of-china-to-taiwan
    case a.Taiwan:
      return m.getName(r, t, { select: "alias" });
    default:
      return m.getName(r, t, { select: "official" });
  }
}, J = (r = s.ENGLISH) => Object.values(a).map((o) => ({
  id: o,
  caption: i(o, r) ?? ""
})), M = (r, o = s.ENGLISH) => i(r, o) ?? "";
export {
  J as getCountryData,
  M as getSingleCountry
};
